import { ActionIcon, Group, Stack, Text, Title, Tooltip } from "@mantine/core";
import { IconExternalLink, IconTrash } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ActionIconLink } from "shared/components/global/ActionIconLink";
import { useArchiveSenderModal } from "shared/components/organization/senders/useArchiveSender";
import { groupsQueryOptions } from "shared/graphql/groups";
import { SenderLikeFragment } from "src/gql/graphql";

const SenderDetails = ({ sender }: { sender: SenderLikeFragment }) => {
    const { openArchiveModal } = useArchiveSenderModal({ sender });

    return (
        <Group key={sender.id} p="sm" gap="xs" style={{ border: "1px solid var(--mantine-color-dimmed)", borderRadius: "0.5rem" }}>
            <Stack gap={0}>
                <Group gap={0} align="flex-start" justify="space-between">
                    <Title order={4} mb="xs">
                        {sender.name}
                    </Title>
                    <Group w="fit-content" gap={0}>
                        <ActionIconLink
                            variant="transparent"
                            aria-label="Edit sender"
                            icon={<IconExternalLink size={16} />}
                            to={"/organization/senders/$senderId"}
                            params={{ senderId: sender.id }}
                        />
                        <Tooltip label="Cannot delete default sender" disabled={!sender.isSystem}>
                            <ActionIcon
                                variant="transparent"
                                color="red"
                                onClick={openArchiveModal}
                                disabled={sender.isSystem}
                                aria-label="Delete sender"
                            >
                                <IconTrash size={16} />
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                </Group>
                {sender.fromEmail && <Text>Email: {sender.fromEmail}</Text>}
                {sender.fromPhone && <Text>Phone: {sender.fromPhone}</Text>}
            </Stack>
        </Group>
    );
};

export const SendersContainer = ({ groupId }: { groupId: string }) => {
    const {
        data: { senders },
    } = useSuspenseQuery(groupsQueryOptions.groupSenders(groupId));

    return (
        <>
            <Title order={3}>Sender Profiles</Title>
            <Group pt="sm">
                {senders.map((sender) => (
                    <SenderDetails sender={sender} key={sender.id} />
                ))}
            </Group>
        </>
    );
};
